import { Outlet } from "react-router-dom";
import WorkerSidebar from "./worker_sidebar";
import WorkerHeader from "../../worker-header/components";
import WorkerFooter from "../../worker-footer/components";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getInfo } from "../slice/workerInfoSlice";

const WorkerDashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      dispatch(getInfo(token));
    }
  }, [dispatch]);

  return (
    <>
      <WorkerHeader />

      <main className="overflow-hidden">
        <section className="homepad">
          <div className="container">
            <div className="row">
              <WorkerSidebar />
              <Outlet />
            </div>
          </div>
        </section>

        <WorkerFooter />
      </main>
    </>
  );
};

export default WorkerDashboard;